import { render, staticRenderFns } from "./SoloDuo.vue?vue&type=template&id=173572aa&"
import script from "./SoloDuo.vue?vue&type=script&lang=js&"
export * from "./SoloDuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports